import styled from "styled-components";

export const AboutMeContainer = styled.div`
	padding-top: 180px;
	background-color: #ffffff;
	display: flex;
	flex-direction: column;
	width: 100%;
`;
